import { useSelector } from "store/useSelector";
import ProductionSegment from "./ProductionSegments/ProductionSegment";

/** {@link LoadingSegmentsIndicator} appears behind all timeline segments, and reveals temporarily during drag */
export default function LoadingSegmentsIndicator({
  timelineIdx,
  height,
  machemetryId,
}) {
  const visibleRange = useSelector(s => s.legacy.visibleRange);
  if (!visibleRange) {
    return null;
  }
  const loadingSegment = {
    segment: {
      pnl: {
        category: "loading",
      },
      range: visibleRange,
    },
    timelineIdx,
    height,
    machemetryId,
  };
  return (
    <g className="loading-segments-indicator" transform={`translate(${0},0)`}>
      <ProductionSegment {...loadingSegment} />
    </g>
  );
}
